// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3TA2Q","row":"Node_row__1HA1J","label":"Node_label__21lTY","footer":"Node_footer__1n1Cc"};